import type { RegisteredSkill } from '../types'
import { READ_SKILLS } from './read-skills'
import { WRITE_SKILLS } from './write-skills'

export const WORD_SKILLS: RegisteredSkill[] = [...READ_SKILLS, ...WRITE_SKILLS]
